<template>
    <div>
        <card>
            <template slot="header">
                <div class="row">
                    <div class="col-md-8">
                        <h3 class="card-title">Evaluation List</h3>
                    </div>
                </div>
            </template>
            <template>
                <nav class="row breadcrumb-tweak">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                        <li class="breadcrumb-item">
                               <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                        </li>
                        <li class="breadcrumb-item active">Employee Evaluation</li>
                    </ol>
                </nav>  
            </template>
            <hr style="margin-top:-10px"/>
            <div class="row">
                <div class="col-md-2">
                    <p>
                        <i class="fa fa-filter"></i> Filter By Year</p>
                    <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                        <option v-for="year in years(2019)">{{ year }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <p>
                            <i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                        <select v-model="page_limit" class="form-control" required>
                            <option value="">Default</option>
                            <option value="2">2</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <p>
                            <i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                        <select v-model="order_by" class="form-control" required>
                            <option value="">Default</option>
                            <option value="1">ASC</option>
                            <option value="-1">DESC</option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- PAGINATION -->
            <b-pagination v-model="curentPage" :total-rows="items.length" :per-page="perPage" aria-controls="my-table" align="right"
                first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>
            <!-- END PAGINATION -->
            <div class="table-responsive ">
                <table class="table table-striped table-hover " v-loading="loading">
                    <tr>
                        <th width="10"></th>
                        <th width="600"></th>
                        <th width="350"></th>
                        <th width="350"></th>
                        <th width="150"></th>
                        <th width="240"></th>
                    </tr>
                    <tbody>
                        <tr v-for="item,index in computedRequest">
                            <td>
                                <span v-if="item.employee_status == 'pending'">
                                    <i class="fa fa-flag danger status-pending" v-b-tooltip.hover title="Waiting for employee to approve"></i>
                                </span>
                                <span v-else-if="item.employee_status == 'approved'">
                                    <i class="fa fa-flag  status-approved" v-b-tooltip.hover title="Request has been approved"></i>
                                </span>
                            </td>
                            <td>
                                <template v-if="item.requester_role_id == '3'">
                                    <span v-if="item.employee_status == 'pending'">
                                        <b>{{item.department_head}}</b> - Evaluated
                                        <b> {{ item.full_name }} </b> for
                                    </span>
                                    <span v-else-if="item.employee_status == 'approved'">
                                         {{item.department_head}} - Evaluated {{ item.full_name }} for
                                    </span>
                                </template>

                                <template v-if="item.requester_role_id == '2'">
                                    <span v-if="item.asm_status == 'pending'">
                                        <b>{{item.supervisor_head}}</b> - Evaluated
                                        <b> {{ item.full_name }} </b> for
                                    </span>
                                    <span v-if="item.asm_status == 'approved' || item.asm_status == 'rejected' ">
                                         {{item.supervisor_head}} - Evaluated {{ item.full_name }} for
                                    </span>
                                </template>
                                <span>
                                    <template v-if="item.description != 'Others' ">({{item.description}})</template>
                                    <template v-else>({{item.others}})</template>
                                </span>
                            </td>
                            <td>
                                <template v-if="item.performance_comments.length < 40">{{ item.performance_comments }}</template>
                                <template v-if="item.performance_comments.length >= 40">{{ item.performance_comments.substring(0,40)+"..." }}</template>
                            </td>
                            <td>
                                <template v-if="item.communication_comments.length < 40">{{ item.communication_comments }}</template>
                                <template v-if="item.communication_comments.length >= 40">{{ item.communication_comments.substring(0,40)+"..." }}</template>
                            </td>
                            <td>
                                <i class="fa fa-calendar-o"></i> {{getDate(item.created_at)}}</td>
                            <td>
                                <template v-if="item.asm_status == 'approved' && item.employee_status == 'approved' && item.tl_status == 'approved'">
                                    <router-link :to="{name: 'performance-details' , params: { id: item.id, employee_id: item.employee_id} }" class="r-link">
                                        <i class="fa fa-eye"></i>&nbsp;View Details</router-link>
                                </template>
                            
                                <template v-else-if="item.asm_status == 'rejected' && item.employee_status == 'pending' && item.tl_status == 'approved'">
                                    <font color="red">
                                        <i class="fa fa-thumbs-down"></i>
                                        <b>REJECTED</b>
                                    </font>
                                </template>
                            
                                <template v-else-if="item.asm_status == 'approved' && item.employee_status == 'pending' && item.tl_status == 'approved'">
                                    <i class="fa fa-spinner fa-pulse"></i>
                                    <b>Waiting ...</b>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <!-- PAGINATION NATIVE WAY -->
                <div class="row">
                    <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                    </div>
                    <div class="col-md-6">
                        <b-pagination v-model="curentPage" :total-rows="items.length" :per-page="perPage" aria-controls="my-table" align="right"
                            first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>
                    </div>
                </div>
                <!-- END PAGINATION -->
            </div>
        </card>
    </div>
</template>
<script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
        components: {
            Card,
        },

        data() {
            return {
                items: [],
                order_by: '',
                //PAGINATION
                page_limit: '',
                filter_by_year: '',
                start_page: 1,
                loading: true,
                perPage: 20,
                curentPage: 1

            }
        },

        created: function () {
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },

        beforeMount: function () {
            this.get_evaluation();
        },

        methods: {
            getYear() {
                if (this.filter_by_year == '') {
                    this.get_evaluation()
                } else {
                    axios.get('api/evaluation/all/' + this.filter_by_year)
                        .then(response => {
                            this.items = response.data;
                        })
                        .catch(error => {
                            console.log(error.response)
                        });
                }
            },

            get_evaluation() {
                axios.get('api/evaluation/all')
                    .then(response => {
                        this.items = response.data
                    })
                    .catch(error => {
                        console.log(error.response)
                    });
            },

        },
        computed: {
            // PAGINATION
            offset() {
                return ((this.start_page - 1) * this.page_limit);
            },

            limit() {
                return ((this.offset + this.page_limit));
            },
            total_item() {
                return this.items.length
            },
            computedRequest() {
                let filtered = this.items
                // USE IN PAGINATION 
                let start = (this.curentPage - 1) * this.perPage
                let end = this.curentPage * this.perPage
                filtered = filtered.slice(start, end)

                if (filtered.length > 0) {
                    // SORTING NUMBER OF DISPLAY
                    if (this.page_limit) {
                        filtered = filtered.slice(this.offset, this.limit);
                        return filtered
                    }
                    // ORDER BY ASC AND DESC COMBOBOX
                    if (this.order_by) {
                        filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
                        return filtered
                    }

                } else {
                    filtered = 0
                }

                return filtered
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-performance/todo-performance.vue